export default __webpack_public_path__ + "static/media/BAKA_ikona_web_odabrano-01.e91558e0.svg";